/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DocType, DocumentView } from './DocumentView'

const TermsOfUse = () => {
    return <DocumentView type={DocType.termsOfUse} />
}

export { TermsOfUse }
